import { createFileRoute } from '@tanstack/react-router';
import MetaSites from '../../../administration/src/components/MetaSites';

export const Route = createFileRoute('/_secured/administration/meta-sites')({
  component: MetaSites,
});
